import React, { useState } from "react";

import { Box, Grid, TextField, Typography } from "@mui/material";

import { InspectionQuota } from "@safetyculture/s12-apis-connect-web/s12/tools/support/v1/support_pb";

interface IncreaseUserInspectionQuotaProps {
  currentQuota: InspectionQuota | undefined;
  maxQuota: number;
  handleNewInspectionQuotaChanged: (newInspectionQuota: number) => void;
}

const getUserInspectionsQuota = (quota: InspectionQuota | undefined) => {
  if (quota) {
    return (
      (quota?.usageLimit || 0) - (quota?.orgQuota || 0) - (quota?.baseLimit | 0)
    );
  }
  return undefined;
};

const IncreaseUserInspectionQuota = ({
  currentQuota,
  maxQuota,
  handleNewInspectionQuotaChanged,
}: IncreaseUserInspectionQuotaProps) => {
  const [numExtraInspections, setNumExtraInspections] = useState(
    getUserInspectionsQuota(currentQuota) || 0,
  );

  return (
    <>
      <Grid container direction="row" spacing={1}>
        <Grid
          item
          xs={9}
          container
          direction="column"
          alignContent={"start"}
          justifyContent={"center"}
        >
          <Box>
            <Typography variant="body1" data-testid={"inspection-quota-label"}>
              Additional user inspection quota (currently{" "}
              {getUserInspectionsQuota(currentQuota)})
            </Typography>
          </Box>
        </Grid>
        <Grid item xs={3} container direction="column" alignContent={"end"}>
          <TextField
            id="customerDeleteRequest-input"
            value={numExtraInspections}
            type="number"
            onChange={(e) => {
              setNumExtraInspections(parseInt(e.target.value));
              handleNewInspectionQuotaChanged(parseInt(e.target.value));
            }}
            variant="outlined"
            size="small"
            inputProps={{
              "data-anchor": "do-numExtraInspections-input",
              "data-testid": "do-numExtraInspections-input",
              min: 0,
              max: maxQuota,
            }}
          />
        </Grid>
      </Grid>
    </>
  );
};

export default IncreaseUserInspectionQuota;
